import React from "react";

import Box from "@mui/material/Box";


import { CssBaseline } from "@mui/material";

import {
    RouteComponentProps,
    withRouter
} from "react-router-dom";

import Routes from "./routes";

import {
    Footer,
    Header
} from "structure";

import { ZPlayNetworkService } from "./commons/zplay-network-service";

type AppProps = RouteComponentProps

class App extends React.Component<AppProps, {}> {

    private closeSearchBar = () => {
        window.dispatchEvent(new Event("searchBar"));
    };

    private checkDontStartsWith = (routeUrl: Array<string>, pathname: string) => {
        let result = true;

        for (let el of routeUrl) {
            if (pathname.startsWith(el) && el !== "/") {
                result = false;
            }
        }

        return result;
    };

    checkIsAPageWithHeader = () => {
        const ROUTES_WITHOUT_HEADER = [
            "/player",
            "/login",
            "/registration",
            "/subscription-success",
            "/subscription-cancel",
            "/subscribe"
        ];

        let returnValue = !ROUTES_WITHOUT_HEADER.includes(this.props.location.pathname);

        returnValue = returnValue && this.checkDontStartsWith(ROUTES_WITHOUT_HEADER, this.props.location.pathname);

        return returnValue;
    };

    public render() {

        let displayHeader = this.checkIsAPageWithHeader();

        ZPlayNetworkService.TOKEN_KEY = "zplay_auth_user_token";
        ZPlayNetworkService.REFRESH_TOKEN_KEY = "zplay_refresh_user_token";

        return (<div style={{ backgroundColor: process.env.REACT_APP_BACKGROUND_COLOR || "#FFFFFF" }}>
            <Box sx={{
                display: "flex",
                bgcolor: process.env.REACT_APP_BACKGROUND_COLOR || "#FFFFFF",
                flexDirection: "column",
                width: "100%",
                minHeight: "100vh"
            }}>
                {displayHeader && <Header />}
                <CssBaseline />
                <Box onClick={() => (this.closeSearchBar())} sx={displayHeader ? {
                    mt: "50px",
                    flexGrow: 1,
                    py: 2
                } : {}}
                    style={{ overflowX: "hidden" }}>
                    <Routes />
                </Box>
                <Footer />
            </Box>
        </div>);
    }
}

export default withRouter(App);
